<template>
  <div class="breadcrumbs box" :class="{'bg-white':mobile, 'p-12':mobile}" id="buyer-breadcrumb">
    <p class="mobile pa-3" v-if="mobile">

      <a href="#" @click="navigateToDashboardPage()">
        <i class="mdi mdi-home"></i>
      </a>
      <span class="title-prev" @click="navigateToDashboardPage()">{{ sectionPage }} ></span>
      <span class="title-current">{{ titlePage }}</span>
      <span class="title-current" v-if="subTitlePage.length">{{ subTitlePage === 'Saldo disponível' ? '' : ' >' }} {{ subTitlePage }}</span>
      <span class="title-current" v-if="thirdTitlePage.length && $route.path === '/buyer/vehicle-detail'"> > {{ thirdTitlePage }}</span>
      
    </p>
    <p class="breadcrumbs" v-if="!mobile">
      <span class="title-current">Você está aqui: </span>
      <span class="title-prev text-orange ml-2" @click="navigateToDashboardPage()" id="breadcrumb-dashboard">{{ sectionPage }} ></span>
      <span class="title-current ml-2">{{ titlePage }}</span>

      <span class="title-current" v-if="subTitlePage.length && $route.path!='/buyer/lot-detail'"> > {{ subTitlePage }}</span>

      <!-- if have lot detail -->
      <span class="title-prev text-orange" v-if="$route.path==='/buyer/lot-detail' && currentStatusLote=='progress'" @click="natigateToLotsInProgressPage()"> > {{ subTitlePage }} > </span>
      <span class="title-prev text-orange" v-if="$route.path==='/buyer/lot-detail' && currentStatusLote=='completed'" @click="natigateToAutoLotsCompletedPurchasesClosedPage()"> > {{ subTitlePage }} > </span>
      <span class="title-current" v-if="$route.path==='/buyer/lot-detail'">
        > <span class="title-prev" @click="() => $router.go(-1)">
          <span class="text-orange" v-if="buyerPackageDetailScope === 'AnnouncementCompleted'" id="breadcrumb-pagamento-pendente">Compras Concretizadas - Avaliações ></span>
          <span class="text-orange" v-if="buyerPackageDetailScope === 'UnfulilledPurchases'" id="breadcrumb-compras-nao-concretizadas-avaliacoes">Compras não concretizadas - Avaliações ></span>
          <span class="text-orange" v-if="buyerPackageDetailScope === 'InProgress'" id="breadcrumb-em-progresso-avaliacaoes">Avaliações ></span>
          <span class="text-orange" v-if="buyerPackageDetailScope === 'PaymentPending'" id="breadcrumb-pagamento-boleto">Pagamento pendente - Boleto ></span>
          <span class="text-orange" v-if="buyerPackageDetailScope === 'ReleasePending'" id="breadcrumb-pagamento-pendente-autopay"> Pagamento Pendente AutoPay ></span>
        </span>
         Pacote {{ lot.ava_id }}
      </span>

      <span
          class="breadcrumbs"
          v-if="dashboardFilter.to || dashboardFilter.from"
      > &nbsp;&gt;
          <span
              class="caption filtros ml-2"
          >
            Filtros
          </span>
          <span class="scroll-filters" @wheel="onWheel">
            <span class="filter-aa">
              <span class="label">&gt; &nbsp;Período:</span>
              <span
                  class="caption caption-item"
                  id="bc-periodo"
                  title="Remover item"
              >
                {{ getPeriodDateLabel() }}
              </span>
              <span @click="removePeriodFilter" class="mdi mdi-close-circle"></span>
            </span>

          </span>
      </span>
    </p>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import store from "@/store";
import { watch, ref, reactive, computed } from "vue";
import NavigateMixings from "@/mixins/NavigateMixings";
import { BUYER } from "@/constants/Buyer";

export default {
  name: "AA-Breadcrumbs",
  props: ["mobile"],
  mixins: [NavigateMixings],
  data() {
    return {
      page: "Página Inicial",
      titleDashboad: BUYER.TITLE_DASHBOARD,
      total: null,
      filtersActive: [],
      filtersLang: {
        period: "Período",
      },
      params: {},
      filters: {
        period: {
          from: null,
          to: null
        },
      },
      filtersHide: ["order"],
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState({
      params: (state) => state.filterForm.params,
      seeAllDrawerObjSelected: (state) => state.drawer.seeAllDrawerObjSelected,
      titlePage: (state) => state.buyer.titlePage,
      subTitlePage: (state) => state.buyer.subTitlePage,
      thirdTitlePage: (state) => state.buyer.thirdTitlePage,
      sectionPage: (state) => state.buyer.sectionPage,
      lot: (state) => state.buyerLotDetail.lotDetail,
      currentStatusLote: (state) => state.buyer.currentStatusLote,
      buyerPackageDetailScope: (state) => state.buyerLotDetail.scope,
      dashboardFilter: (state) => state.buyer.dashboardFilter.period
    }),
  },
  methods: {
    ...mapActions("filterForm", ["search"]),
    ...mapMutations("drawer", [
        "showSeeAllDrawer",
        "setSeeAllDrawerObjDetails",
        "unsetSeeAllDrawerObjSelected",
        "clearSeeAllDrawerObjSelected",
        "clear"
      ]),
    ...mapMutations("buyer", [
        "deleteDashboardFilter"
      ]),
    getDateNow(dateStr = null) {
      if (!dateStr) {
        const dateObj = new Date();
        return dateObj.toLocaleDateString('pt-BR');
      }
      dateStr = dateStr.toString();
      const [y, m, d] = dateStr.split('-').map(Number);
      const date = new Date(y, m - 1, d);
      return date.toLocaleDateString('pt-BR');
    },
    getPeriodDateLabel() {
      const dataFrom = this.dashboardFilter.from ? this.getDateNow(this.dashboardFilter.from) : null;
      const dataTo = this.dashboardFilter.to ? this.getDateNow(this.dashboardFilter.to) : null;

      if (dataFrom && dataTo) {
        return `${dataFrom} até ${dataTo}`;
      }
      if (dataFrom) {
        return `de ${dataFrom}`;
      }
      if (dataTo) {
        return `até ${dataTo}`;
      }
      return '';
    },
    removePeriodFilter() {
      this.deleteDashboardFilter()
    },
    init() {
      this.filtersActive = store.state.filterForm.params;
    },
    select(field) {
      let el = document.querySelector("div[data-name=" + field + "]");
      if (!el) return;
      //el.scrollIntoView();
      el.focus();
      el.click();
    },
    getValue(v = false, k = false) {
      let sufix = '';
      if(k == 'fipe') sufix = '%';
      if (typeof v === "null") return false;
      if (typeof v === "undefined") return false;
      if (typeof v === "array" || typeof v === "object") {
        v = v.map((elem) => {
          if (typeof(elem) === 'string') return elem;
          if ("title" in elem) return elem.title;
          if ("name" in elem) return elem.name;
          if ("value" in elem) return elem.value;
          return elem;
        });
      }
      if (typeof v === "object") v = v.join(", ");
      return v + sufix;
    },
    onWheel(ev) {
      let mov = ev.deltaY;
      document.querySelector(".scroll-filters").scrollLeft += mov / 3;
    }
  },
};
</script>

<style lang="scss" scoped>

$orange: #ff9900;

.title-current{
  color: #5b5b5b;
  font-size: 11px;
  font-family: "Lexend Deca";
  font-weight: 400;
  word-wrap: break-word;
  margin-right: 4px !important;
  margin-left: 0 !important;
}
.title-prev{
  color: #FF7A00;
  font-size: 11px;
  font-family: "Lexend Deca";
  font-weight: 400;
  word-wrap: break-word;
  cursor: pointer;
  margin-right: 4px !important;
  margin-left: 4px !important;
}

/* Sobrescrever classes do Vuetify */
#buyer-breadcrumb .ml-2 {
  margin-left: 4px !important;
}

.content-top {
  &.mobile {
    .breadcrumbs.box {
      height: auto;
      font-size: 0.8rem;
    }

    .breadcrumbs {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: flex;
    }

    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
.breadcrumbs.box {
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  height: 3em;
  line-height: 12px;

  p.breadcrumbs {
    overflow-x: auto;
    display: inline-flex;
    max-width: calc(100% - 1em);
    white-space: nowrap;
    top: 0;
    padding: 0.5em 0;
    margin-top: 0;
    margin-bottom: 0;
    align-items: center;
    align-items: center;
  }

  p.breadcrumbs::-webkit-scrollbar {
    height: 4px;
    background-color: #f5f5f5;
  }

  p.breadcrumbs::-webkit-scrollbar-thumb {
    height: 4px;
    background-color: lightgray;
  }
}
p.breadcrumbs,
p.breadcrumbs span {
  font-family: "Lexend Deca", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #424242;
  letter-spacing: -0.8px;
}
p.breadcrumbs span.label {
  text-transform: capitalize;
  color: #424242;
  font-size: inherit;
  font-weight: 400;
  margin: 0 3px;
}
p.breadcrumbs i.fa,
.mdi {
  color: #ff9900 !important;
  font-size: 1.2rem !important;
  margin-right: 0.1em;
  position: relative;
  top: 2px;
  cursor: pointer;
}
p.breadcrumbs .caption {
  color: #ff9900;
  font-weight: 400;
  font-size: inherit;
  text-transform: capitalize;
  margin-right: 0.1em;
}

p.breadcrumbs a.home {
  text-decoration: none;
}

p.breadcrumbs .home {
  color: $orange !important;
}
.caption.home,
.caption.filtros {
  color: #aaa !important;
}
.nextArrow {
  margin: 0 0.2em;
}

.filter-aa:last-child .nextArrow {
  display: none;
}
</style>
